import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import CONFIG from "@/config/siteConfig";

// Set browser tab title, description, and favicon from config
document.title = CONFIG.tabTitle || 'CLASSIFIED // UMBRELLA CORP';
if (CONFIG.siteDescription) {
  const meta = document.querySelector('meta[name="description"]');
  if (meta) meta.content = CONFIG.siteDescription;
  const ogDesc = document.querySelector('meta[property="og:description"]');
  if (ogDesc) ogDesc.content = CONFIG.siteDescription;
  const ogTitle = document.querySelector('meta[property="og:title"]');
  if (ogTitle) ogTitle.content = CONFIG.tabTitle || '';
}
if (CONFIG.tabIcon) {
  const link = document.querySelector("link[rel~='icon']") || document.createElement('link');
  link.rel = 'icon';
  if (CONFIG.tabIcon.startsWith('/') || CONFIG.tabIcon.startsWith('http')) {
    link.href = CONFIG.tabIcon;
  } else {
    link.href = `data:image/svg+xml,<svg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 100 100%22><text y=%22.9em%22 font-size=%2290%22>${encodeURIComponent(CONFIG.tabIcon)}</text></svg>`;
  }
  document.head.appendChild(link);
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
